import { COURSE_IMAGES } from './courseImages.js';

const zeroFourMaterials = [
  '“ABC de lactancia”: para que puedas prepararte para la lactancia y puedas sacarte las dudas más frecuentes. A cargo de la puericultora Sabrina Brunasco.',
  'Puerperio saludable y Depresión post parto: cuáles son los síntomas esperables del puerperio y cuáles son las señales de alarma que requieren ayuda profesional. A cargo de la psicóloga Maria Lodola (consultora del equipo de Lucila Pistiner).',
  'Guía completa sobre tu suelo pélvico durante el embarazo y el posparto: para entenderlo y cuidarlo.',
  'Vídeo grabado con preguntas y respuestas realizadas en Talleres en vivo de Lucila.'
];

const zeroFourContent = [
  'Fundamentos del sueño seguro.',
  'Determinar cuándo acostarlo para las siestas y la noche.',
  'Técnicas para calmar a tu bebé irritable o con llanto inconsolable.',
  'Cómo organizar una rutina diaria flexible.',
  'Optimizar su ambiente de sueño.',
  'Ayudar a tu bebe con la confusión noche-día.',
  'Mejorar su sueño nocturno.',
  'Reconocer los cambios biológicos que atravesará tu bebé y cómo adaptarte a ellos.',
  'Consejos para sobrellevar la regresion del cuarto mes.',
  'Evitar la sobre-estimulación.',
  'Comprender porqué llora tu bebé',
  'Resolver dudas frecuentes.',
  'Guía resumen mes a mes'
];

export const firstFoodsFaqs = [
  {
    question: '¿Qué método de alimentación enseña el curso?',
    answer: 'Hablamos sobre BLW (bliss) y papilla participativa. Explicamos los dos métodos para que empieces de la manera que te sientas más cómoda/o y seguro/a.'
  },
  {
    question: '¿Qué edad debería tener mi bebé para tomar el curso?',
    answer: 'Entre 5 y 12 meses.'
  },
  {
    question: 'Ya empezamos a alimentar a mi bebé con cuchara, ¿el curso me sirve igual?',
    answer: 'Sí. Te enseñamos a hacer la transición a trozos y adaptamos los cortes para que puedas avanzar con seguridad.'
  },
  {
    question: '¿Cuál es la duración de las grabaciones?',
    answer: 'El curso incluye 71 minutos de videos.'
  }
];

export const courseCatalog = {
  '0-4-meses': {
    path: '/cursos/0-4-meses',
    title: 'Sueño en bebés de 0 a 4 meses',
    seoTitle: 'Sueño en bebés de 0 a 4 meses | Lucila Pistiner',
    description: 'Curso online para embarazadas, mamás y papás de bebés de 0 a 4 meses. Herramientas para sentar bases saludables de sueño desde el inicio.',
    shortDescription: 'Herramientas para sentar bases saludables de sueño desde el inicio.',
    category: 'Sueño infantil',
    audience: 'Embarazadas, mamás y papás de bebés de 0 a 4 meses',
    heroAudience: 'Curso online para embarazadas, mamás y papás de bebés de 0 a 4 meses',
    subtitle: 'Sentando bases saludables del sueño',
    chapters: '37 capítulos',
    priceArs: 49000,
    arsLabel: 'AR$ 49.000,00',
    priceUsd: 45,
    usdLabel: 'U$S 45,00',
    buyHref: 'https://lucilapistiner.wisboo.com/checkout/sueno-en-bebes-de-0-a-4-meses?pricing=93858&country=AR',
    image: COURSE_IMAGES.zeroToFour,
    intro: 'Quiero dejarte recursos y herramientas para que puedas identificar las necesidades de tu bebé (hambre, sueño, contacto, y otras), te sientas más segura/o y puedas disfrutar de esta etapa única. Este curso es compatible con LME y colecho seguro.',
    includes: zeroFourContent,
    materials: zeroFourMaterials,
    ideal: [
      'Si estás embarazada, en tu último mes de embarazo.',
      'Si ya nació tu bebé, en sus primeras semanas.',
      'O en cualquier momento antes que cumpla 12 semanas.'
    ]
  },
  '4-20-meses': {
    path: '/cursos/4-20-meses',
    title: 'Sueño en bebés de 4 a 20 meses',
    seoTitle: 'Sueño en bebés de 4 a 20 meses | Lucila Pistiner',
    description: 'Curso online para comprender el sueño de bebés de 4 a 20 meses y crear rutinas saludables de descanso.',
    shortDescription: 'Cómo comprender el sueño de bebés de 4 a 20 meses y crear rutinas saludables de descanso.',
    category: 'Sueño infantil',
    audience: 'Mamás y papás de bebés de 4 a 20 meses',
    subtitle: 'Creando rutinas saludables de sueño',
    chapters: '49 capítulos',
    priceArs: 55000,
    arsLabel: 'AR$ 55.000,00',
    priceUsd: 50,
    usdLabel: 'U$S 50,00',
    buyHref: 'https://lucilapistiner.wisboo.com/checkout/sueno-en-bebes-de-4-a-20-meses?pricing=94345&country=AR',
    image: COURSE_IMAGES.fourToTwenty,
    intro: 'Recursos para entender cómo funciona el sueño de tu bebé e iniciar un camino posible hacia un mejor descanso.',
    includes: [
      'Fisiología, sueño seguro y cuatro pilares de higiene',
      'Siestas, rutinas y horarios según la edad',
      'Transiciones, regresiones y situaciones frecuentes'
    ],
    ideal: [
      'Tu bebé tiene entre 4 y 20 meses',
      'Necesitás ordenar la rutina diaria',
      'Querés anticiparte a los cambios de cada etapa'
    ]
  },
  'destete-nocturno': {
    path: '/cursos/destete-nocturno',
    title: 'Destete nocturno',
    seoTitle: 'Destete nocturno | Lucila Pistiner',
    description: 'Curso online para reducir o eliminar tomas nocturnas desde un enfoque respetuoso, progresivo y con apego.',
    shortDescription: 'Una guía para reducir o eliminar las tomas nocturnas de pecho o mamadera.',
    category: 'Sueño infantil',
    audience: 'Familias que desean reducir tomas nocturnas',
    subtitle: 'Un enfoque respetuoso, progresivo y con apego',
    chapters: '26 capítulos',
    priceArs: 40000,
    arsLabel: 'AR$ 40.000,00',
    priceUsd: 40,
    usdLabel: 'U$S 40,00',
    buyHref: 'https://lucilapistiner.wisboo.com/checkout/destete-nocturno-6f70b91c-a4df-4a71-837c-e46bb3b4319f?pricing=98787',
    image: COURSE_IMAGES.nightWeaning,
    intro: 'Una guía para reducir o eliminar las tomas nocturnas de pecho o mamadera cuidando el vínculo y el descanso.',
    includes: [
      'Estrategias ajustadas a cada familia',
      'Guías descargables y diario de sueño',
      'Material sobre apego y seguridad emocional'
    ],
    ideal: [
      'Tu bebé tiene más de 9 meses',
      'Las tomas nocturnas ya no son sostenibles',
      'Querés avanzar sin abandonar el colecho si así lo elegís'
    ]
  },
  'lo-que-necesitamos-saber': {
    path: '/cursos/lo-que-necesitamos-saber',
    title: 'Lo que necesitás saber cuando nace el bebé',
    seoTitle: 'Lo que necesitás saber cuando nace el bebé | Lucila Pistiner',
    description: 'Curso online para prepararte para el nacimiento, primeros cuidados del recién nacido, lactancia y sueño seguro.',
    shortDescription: 'Qué esperar durante el nacimiento y las primeras semanas del recién nacido.',
    category: 'Recién nacido',
    audience: 'Embarazadas, familias y acompañantes',
    subtitle: 'Primeros cuidados del recién nacido y lactancia',
    chapters: '15 capítulos',
    priceArs: 40000,
    arsLabel: 'AR$ 40.000,00',
    priceUsd: 45,
    usdLabel: 'U$S 45,00',
    buyHref: 'https://lucilapistiner.wisboo.com/checkout/lo-que-necesitamos-saber-cuando-nace-el-bebe?pricing=100278&country=AR',
    image: COURSE_IMAGES.newborn,
    intro: 'Información práctica para vivir el nacimiento y las primeras semanas en casa con menos incertidumbre y más confianza.',
    includes: [
      'Parto, controles, vacunas y primeros cuidados',
      'Lactancia, sueño seguro, baño y cordón umbilical',
      'Llanto, cólicos, señales normales y señales de alerta'
    ],
    ideal: [
      'Estás desde la semana 30 de embarazo',
      'Querés prepararte para la llegada del bebé',
      'Buscás información basada en evidencia'
    ]
  },
  'primeros-alimentos': {
    path: '/cursos/primeros-alimentos',
    title: 'Curso primeros alimentos',
    seoTitle: 'Curso primeros alimentos | Lucila Pistiner',
    description: 'Curso online sobre primeros alimentos, alimentación complementaria y BLW para familias de bebés de 5 a 12 meses.',
    shortDescription: 'Una guía simple y práctica para acompañar el inicio de la alimentación complementaria con información confiable.',
    category: 'Nutrición infantil',
    audience: 'Mamás y papás de bebés de 5 a 12 meses',
    subtitle: 'Nutrición y alimentación infantil',
    chapters: '10 capítulos',
    priceArs: 40000,
    arsLabel: 'AR$ 40.000,00',
    priceUsd: 45,
    usdLabel: 'U$S 45,00',
    buyHref: 'https://lucilapistiner.wisboo.com/checkout/blw-y-primeros-alimentos?pricing=94589&country=AR',
    image: COURSE_IMAGES.firstFoods,
    intro: 'Una guía simple y práctica para acompañar el inicio de la alimentación complementaria con información confiable.',
    includes: [
      'Introducción progresiva de alimentos',
      'Herramientas para una alimentación segura',
      'Clases on demand y recursos prácticos'
    ],
    ideal: [
      'Tu bebé está listo para comenzar a comer',
      'Querés resolver dudas sobre alimentación',
      'Buscás avanzar con tranquilidad'
    ],
    faqs: firstFoodsFaqs
  },
  combos: {
    path: '/cursos/combos',
    title: 'Combos de cursos',
    seoTitle: 'Combos de cursos | Lucila Pistiner',
    description: 'Combos de cursos online para acompañar distintas etapas: sueño infantil, nacimiento, destete nocturno y alimentación.',
    shortDescription: 'Combinaciones de cursos para acompañar distintas etapas del sueño, nacimiento y alimentación.',
    category: 'Cursos combinados',
    audience: 'Recursos para acompañar distintas etapas',
    subtitle: 'Más herramientas para tu familia',
    chapters: 'Cursos combinados',
    image: '/combos/recien-nacido.webp',
    intro: 'Combiná contenidos de sueño, nacimiento, destete y alimentación para acompañar las necesidades de tu familia en cada etapa.',
    includes: [
      'Combo recién nacido',
      'Combo sueño y destete nocturno',
      'Combo sueño y alimentación'
    ],
    ideal: [
      'Querés abordar más de una etapa',
      'Buscás una propuesta integral',
      'Querés elegir el combo que mejor se adapte a ustedes'
    ]
  }
};

export function getCourseBySlug(slug) {
  return courseCatalog[slug];
}
